import { FC, useMemo } from "react";
import { parseCEP } from "src/framework/commons/masks";
import { ChangeValue, CustomTextField } from "../InputParameters";
import { InputText, InputTextParameters } from "../InputText";

export interface InputCEPProperties extends InputTextParameters, CustomTextField {
    validarCep?: boolean
}

const InputCEP: FC<InputCEPProperties> = ({
    fullWidth = true,
    validarCep = true,
    onChangeValue,
    ...props
}) => {

    const cepInvalido = useMemo(() => {
        return validarCep && !!props?.value?.length && props?.value?.length < 9;
    }, [props?.value, validarCep]);
    
    return (
        <InputText
            {...props}
            mask="cep"
            fullWidth={fullWidth}
            error={cepInvalido}
            helperText={cepInvalido && (props?.helperText || "CEP inválido")}
            onChange={(e: any) => {
                const val = e.target.value;
                const inputType = e?.nativeEvent?.inputType;
                
                if (inputType !== "deleteContentBackward" && val?.replace(/\D/g, "")?.length > 8) {
                    return;
                }

                if (props.onChange) {
                    props.onChange(e)
                }

                if (onChangeValue) {
                    const newValue: ChangeValue = {
                        name: props?.name ? props.name : null,
                        value: inputType === 'deleteContentBackward' ? val : parseCEP(val),
                        numberValue: Number(val.replace(/\D/g, ""))
                    }

                    onChangeValue(newValue)
                }
            }}
        />
    );
}

export { InputCEP }